import { Controller, FieldValues, Path, UseFormReturn } from 'react-hook-form';
import { AgCheckbox } from 'app/agriculture/components/form/AgCheckbox/AgCheckbox';

interface CheckboxFieldComponentProps<FormType extends FieldValues> {
    fieldName: Path<FormType>;
    noun: string;
    formController: UseFormReturn<FormType>;
}

export function CheckboxFieldComponent<FormType extends FieldValues>({
    fieldName,
    noun,
    formController,
}: CheckboxFieldComponentProps<FormType>) {
    const { control } = formController;

    return (
        <Controller
            name={fieldName}
            control={control}
            render={({ field }) => (
                <AgCheckbox
                    id={`entity-${fieldName}-checkbox`}
                    defaultChecked={!!field.value}
                    onChange={field.onChange}
                    label={noun}
                />
            )}
        />
    );
}
